import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none" } }, [_c("g", { attrs: { "opacity": "0.8" } }, [_c("path", { attrs: { "d": "M8.74935 15.8337C12.6613 15.8337 15.8327 12.6623 15.8327 8.75033C15.8327 4.83833 12.6613 1.66699 8.74935 1.66699C4.83735 1.66699 1.66602 4.83833 1.66602 8.75033C1.66602 12.6623 4.83735 15.8337 8.74935 15.8337Z", "stroke": "currentColor", "stroke-width": "1.5", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M13.8418 13.8428L17.3773 17.3783", "stroke": "currentColor", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" } })])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const SearchIcon = __component__.exports;
export {
  SearchIcon as default
};
